(function () {
var $a8d036b1ee805721$exports = {};
var $a8d036b1ee805721$var$burger = document.querySelector(".burger");
var $a8d036b1ee805721$var$menu = document.querySelector(".menu");
var $a8d036b1ee805721$var$burgerTitle = document.querySelector(".burger-menu-title");
// Overlay flouté
var $a8d036b1ee805721$var$overlay = document.createElement("div");
$a8d036b1ee805721$var$overlay.classList.add("menu-overlay");
document.body.appendChild($a8d036b1ee805721$var$overlay);
var $a8d036b1ee805721$var$toggleMenu = function toggleMenu() {
    $a8d036b1ee805721$var$menu.classList.toggle("is-active");
    $a8d036b1ee805721$var$burger.classList.toggle("is-active");
    $a8d036b1ee805721$var$overlay.classList.toggle("is-active");
    $a8d036b1ee805721$var$burgerTitle.textContent = $a8d036b1ee805721$var$burger.classList.contains("is-active") ? "CLOSE" : "MENU";
};
$a8d036b1ee805721$var$burger.addEventListener("click", $a8d036b1ee805721$var$toggleMenu);
$a8d036b1ee805721$var$overlay.addEventListener("click", $a8d036b1ee805721$var$toggleMenu);

})();
//# sourceMappingURL=index.84bcab2d.js.map
